module.exports = __webpack_public_path__ + "static/media/btct.676f7fec.svg";